import React from 'react';
import { LinearProgress } from 'material-ui';

export default () => <LinearProgress color="tomato" />;



// WEBPACK FOOTER //
// ./src/components/LinearProgress.js